import {useAppSelector} from "./redux";
import {selectCurrentUser} from "../features/users/model/selectors";

/**
 * Права у всех одинаковые (решение владельца 24.10): гейты requiresAdmin
 * открыты любому вошедшему. is_admin с бэка нужен только служебному
 * POST /api/max/test-alert и в UI не используется.
 */
export const useIsAdmin = (): boolean => {
    const currentUser = useAppSelector(selectCurrentUser);
    return Boolean(currentUser);
};